module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 35
// module chunks = 0